import {Dispatch} from 'redux';

import {LOGOUT_USER_REQUEST} from './constants';

export function logout() {
    return (dispatch: Dispatch) => {
        dispatch({type: LOGOUT_USER_REQUEST});
    };
}
